/**
 * The headline figures' sizing, apart from `stat-tiles.tsx` so the budget is testable without React.
 *
 * Why each part is there: docs/notes/portals/stat-figure.md
 */

/**
 * Measured: 0.478em per character in Rethink Sans at `tracking-tight` (production's "24.753.869,99 €" is
 * 344px at 48px), so 7.8 holds sixteen with ~2% margin. A constant divisor keeps the type size following
 * the tile, never the digits. Calibrate against production, not seed data.
 */
export const FIGURE_EM = 7.8;

/** "999.999.999,99 €": every total below a billion, one digit of headroom over production's fifteen. */
export const MAX_FIGURE_CHARS = 16;

/**
 * Sized from the tile (`cqi`), not the viewport, because past 1280 the bento stops growing; 3rem is the
 * hand-off's ceiling. The divisor is a literal for Tailwind, pinned to `FIGURE_EM` by the test.
 */
export const FLUID_FIGURE = 'tracking-tight text-3xl whitespace-nowrap md:[font-size:min(3rem,calc(100cqi/7.8))]';
